// CSV生成・ダウンロード用ユーティリティ

// Excelでの数式実行（CSVインジェクション）対策
const sanitizeCell = (value) => {
  let s = value === null || value === undefined ? '' : String(value);
  if (/^[=+@\t\r-]/.test(s)) {
    s = `'${s}`;
  }
  return s;
};

const escapeCell = (value) => `"${sanitizeCell(value).replace(/"/g, '""')}"`;

// headers: string[], rows: any[][] → BOM付きCSV文字列（Excel文字化け対策）
export const buildCsv = (headers, rows) => {
  const lines = [headers, ...rows].map(row => row.map(escapeCell).join(','));
  return '\uFEFF' + lines.join('\r\n');
};

export const downloadCsv = (filename, csvString) => {
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
